import { createAction } from '@reduxjs/toolkit';

import type { CartProduct } from 'domains/cart_products';

type AddToCartType = 'standard' | 'multiphoto';

const addToCart = {
  pending: createAction<AddToCartType>('cartProductCreator/addToCart/pending'),
  ready: createAction<AddToCartType>('cartProductCreator/addToCart/ready'),
  fulfilled: createAction<CartProduct[]>('cartProductCreator/addToCart/fulfilled'),
  rejected: createAction('cartProductCreator/addToCart/rejected'),
};

const saveCartProductEdit = {
  pending: createAction('cartProductCreator/saveCartProductEdits/pending'),
  fulfilled: createAction<{ update: CartProduct; removeId: number }>(
    'cartProductCreator/saveCartProductEdit/fulfilled'
  ),
  rejected: createAction('cartProductCreator/saveCartProductEdit/rejected'),
};

export default {
  addToCart,
  saveCartProductEdit,
};
